import { User } from "../../../domain/model/user";
import { StoreEntityId } from "../store-entity-id";
import { SyncStoreUpdateData } from "../sync-store-update-data";
import { SyncStoreSaveUnit } from "./sync-store-save-unit";

export class SyncStoreSaveData<T extends SyncStoreUpdateData> implements SyncStoreSaveUnit<T> {

  constructor(
    readonly id: StoreEntityId,
    readonly time: Date,
    readonly user: User,
    readonly data: Array<T>) { }
}
